
import Collectable from './Collectable';
import Library from '../utility/Library';
import User from '../../User';

const ALTAR_IMAGES = [
	"https://moa-pull.b-cdn.net/assets/buildings/altaramber.png",
	"https://moa-pull.b-cdn.net/assets/buildings/altarruby.png",
	"https://moa-pull.b-cdn.net/assets/buildings/altarpearl.png",
	"https://moa-pull.b-cdn.net/assets/buildings/altarberyl.png",
	"https://moa-pull.b-cdn.net/assets/buildings/altarspinelle.png"
]

export default class Treasure {

	constructor (run, type="treasure") {

		this.run = run;
		this.type = type;
		this.collectables = [];
		this.run.notify('newtreasure', this, run, type);
	}

	empty () {

		return this.collectables.length === 0;
	}

	get entity () {

		if (this.type === "treasure")
			return {
				id: { type: "treasure", no: 1 },
				name: "Treasure",
				scale: 1,
				img: "https://moa-pull.b-cdn.net/assets/buildings/treasure.png",
				static: true
			}
		else if (this.type === "chest")
			return {
				id: { type: "chest", no: 1 },
				name: "chest",
				scale: 0.9,
				img: "https://moa-pull.b-cdn.net/assets/buildings/chest.png",
				static: true
			}
		else if (this.type === "altar")
			return {
				id: { type: "altar", no: 1 },
				name: "altar",
				scale: this.run.champion.model.key === 4 ? 2.3 : 1.8,
				img: ALTAR_IMAGES[this.run.champion.model.key-1],
				static: true
			}
	}

	take (no) {

		if (!this.collectables[no])
			return;

		this.collectables.splice(no, 1)[0].collect();

		this.run.notify('taketreasure', this, no)
	}

	remove (no) {

		if (!this.collectables[no])
			return;

		this.collectables.splice(no, 1);

		this.run.notify('taketreasure', this, no)
	}

	generateTreasure (type, value) {

		let collectable = new Collectable(this.run, type, value);
	  	this.collectables.push(collectable);
		this.run.notify('generatetreasure', this, collectable);
	}

	generateRelic () {

		let relic = this.run.generateRelic();
		let collectable = new Collectable(this.run, "relic", relic);
	  	this.collectables.push(collectable);
	  	User.learn("relics", relic.key);
		this.run.notify('generatetreasure', this, collectable);
	    return relic;
	}

	generateItem () {

		let items = Object.values(Library.potions);
		items = items.filter(item => item.rarity && (!item.rank || this.run.power >= item.rank) && (!item.champion || item.champion === this.run.champion.key))
		//items = items.filter(item => !this.run.champion.items.some(r => r.key === item.key))

		const weightedArray = items.flatMap(item => {
	    	let weight = 0;
	        if (item.rarity === 2) weight = 2;
	        else if (item.rarity === 3) weight = 1;
	        else weight = 3;

	        return Array(weight).fill(item);
	    });

		let item = Library.upgradeItem(weightedArray[Math.floor(Math.random() * weightedArray.length)], this.run.power);
		let collectable = new Collectable(this.run, "potion", item);
	  	this.collectables.push(collectable);
		this.run.notify('generatetreasure', this, collectable);
	    return item;
	}

	serialize () {

		return {
			collectables: this.collectables.map(c => c ? c.serialize() : null),
			type: this.type
		}
	}

	static build (run, src) {

		let treasure = new Treasure(run);
		treasure.collectables = src.collectables.map(c => c && c.type !== "shards" ? Collectable.build(run, c) : null);
		treasure.type = src.type;
		return treasure;
	}
}
